import { useUserEventLogger } from '@repo/tracking-service';
import { Button } from '@zenterprise-inc/ui';
import { useRef } from 'react';

import s from './Reviews.module.scss';

const ReviewsMain = ({ openVideoPopup }: { openVideoPopup: (videoLink: string) => void }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const { sendClickEvent } = useUserEventLogger();

  const playVideo = () => {
    sendClickEvent('landing_review_reviews-main');
    openVideoPopup('https://www.youtube.com/embed/8DIZ6d8vfDU');
  };

  return (
    <div className={'flex justify-center'}>
      <div className={'app-side-padding heading-3 flex w-full max-w-screen-lg flex-col whitespace-pre-line'}>
        <div className={'relative'}>
          <video
            ref={videoRef}
            className={'relative brightness-110'}
            autoPlay
            loop
            playsInline
            muted
            poster={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/reviews/refund-review-background.png`}
          >
            <source src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/videos/refund-review-background2.webm`} type="video/webm" />
            <source src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/videos/refund-review-background2.mp4`} type="video/mp4" />
          </video>
          <div className={s.radial} />
        </div>
        <div className={'relative py-[2em]'}>
          <div className={'heading-2'}>
            세무, 비대면으로
            <br />
            <span className="highlight-gradient bznav-main shimmer">처리해도 괜찮더군요</span>
          </div>
          <div className="paragraph-3 pt-[1em] font-semibold text-gray-600">
            “나중에 문제 생기면 어떡하나 고민했는데, 환급받기 애매한 부분은 <span>최대한 보수적으로</span> 운용하셨다는 얘길 들었어요. 그 말 듣고 전{' '}
            <span>매년 믿고 맡겨보기로 했어요.</span>&quot;
          </div>
          <div className="paragraph-5 pb-[2em] pt-[1em]">
            <div className="paragraph-5 pt-[0.75em] font-medium text-gray-900">곽지영 대표님</div>
            <div className="paragraph-6 flex items-center pt-[0.325em] font-medium text-gray-600">
              <span className={`mr-[0.25em] pr-[0.25em] ${s.reviews_divider}`}>토탈네트워크</span>
              <span>인력 컨설팅</span>
            </div>
          </div>
          <div>
            <Button.Text size={'large'} className={s.reviews_main_video_play_button} onClick={playVideo}>
              영상 보기
            </Button.Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewsMain;
